import React, { useEffect, useState } from 'react';
import { object, bool, func } from 'prop-types';
import { connect, shallowEqual, useDispatch } from 'react-redux';
import { useRouteMatch, withRouter } from 'react-router-dom';
import { scrollToTop } from '../../services/util/CommonUtil';
import ClientActions from '../../store/clientRedux';
import ProductActions from '../../store/productRedux';
import Section from '../../components/layout/Section';
import ContentPlain from '../../components/layout/ContentPlain';
import DiyNetfileStatusCard from './components/DiyNetfileStatusCard';
import DiyRefileStatusCard from './components/DiyRefileStatusCard';
import DiyReturnSummary from './components/DiyReturnSummary';
import PaymentInfo from '../../components/paymentInformation/PaymentInfo';
import AuditProtectionCard from './components/AuditProtectionCard';
import ExpertReviewCard from './components/ExpertReviewCard';
import QuickLinksCard from './components/QuickLinksCard';
import SkeletonStatusCard from './components/SkeletonStatusCard';
import StackableCardWrapper from '../../components/library/stacking-collapsible-cards/StackableCardWrapper';
import '../../stylesheets/productPages.scss';
import './DiyReturnPage.scss'

const DiyReturnPage = props => {

    const match = useRouteMatch()
    const dispatch = useDispatch()

    const { diyReturn, isLoading, auditProtection, expertReview, hideJsonButtons } = props

    const { taxYear, clientId, id: viewModelId } = match.params

    const [returnInfo, setReturnInfo] = useState({});

    useEffect(() => {
        dispatch(ProductActions.getAuditProtection(taxYear, viewModelId))
        dispatch(ProductActions.getExpertReview(taxYear, viewModelId))
        dispatch(ProductActions.getSelectedDiyReturn({
            taxYear: taxYear,
            product: 'DIY',
            id: viewModelId,
            clientId: clientId
        }))
        scrollToTop()
    }, [viewModelId])

    useEffect(() => {
        if (Boolean(diyReturn) && Boolean(diyReturn.returnInfo) && !shallowEqual(diyReturn.returnInfo, returnInfo)) {
            setReturnInfo(diyReturn.returnInfo)
        } else if (!Boolean(diyReturn) && !shallowEqual(returnInfo, {})) {
            setReturnInfo({})
        }
    }, [diyReturn])

    return (
        <div className="content-grid">
            <DiyReturnSummary isLoading={isLoading || !returnInfo} returnInfo={returnInfo} />
            <Section sectionId='section-return-details' className='light-functional-grey'>
                <ContentPlain elementId='diyReturnContent'>
                    {(!diyReturn || diyReturn.loadingProductHistory) &&
                        <StackableCardWrapper className='card-filing-status-skeleton'>
                            <SkeletonStatusCard />
                        </StackableCardWrapper>
                    }
                    {(diyReturn && diyReturn.returnStatuses && diyReturn.returnStatuses.length > 0 && !diyReturn.returnStatuses.some(r => r.isRefile)) &&
                        <DiyNetfileStatusCard id="PRIMARY" returnInfo={returnInfo} returnStatii={diyReturn.returnStatuses} hideJsonButtons={hideJsonButtons} />
                    }
                    {(diyReturn && diyReturn.returnStatuses && diyReturn.returnStatuses.length > 0 && diyReturn.returnStatuses.some(r => r.isRefile)) &&
                        <DiyRefileStatusCard id="PRIMARY" returnInfo={returnInfo} returnStatii={diyReturn.returnStatuses} hideJsonButtons={hideJsonButtons} />
                    }
                    {(diyReturn && diyReturn.returnStatuses && diyReturn.returnStatuses.length > 0 && !diyReturn.returnStatuses.some(r => r.isRefile) && returnInfo.returnType !== 'SINGLE') &&
                        <DiyNetfileStatusCard id="SPOUSE" returnInfo={returnInfo} returnStatii={diyReturn.returnStatuses} hideJsonButtons={hideJsonButtons} />
                    }
                    {(diyReturn && diyReturn.returnStatuses && diyReturn.returnStatuses.length > 0 && diyReturn.returnStatuses.some(r => r.isRefile) && returnInfo.returnType !== 'SINGLE') &&
                        <DiyRefileStatusCard id="SPOUSE" returnInfo={returnInfo} returnStatii={diyReturn.returnStatuses} hideJsonButtons={hideJsonButtons} />
                    }
                    {diyReturn &&
                        <div className='mb-5'>
                            <PaymentInfo payments={diyReturn.paymentInformations} />
                        </div>
                    }                   
                    {diyReturn && diyReturn.canSeeExpertHelp &&
                        <ExpertReviewCard expertReview={expertReview} taxYear={taxYear} />
                    }
                    {diyReturn && diyReturn.canSeeAuditProtection &&
                        <AuditProtectionCard paymentInfo={diyReturn.paymentInformations} returnInfo={returnInfo} />
                    }
                    <QuickLinksCard />
                </ContentPlain>
            </Section>
        </div>
    );
}

DiyReturnPage.propTypes = {
    diyReturn: object,
    isLoading: bool,
    auditProtection: object,
    expertReview: object,
    getReturn: func,
    getAuditProtection: func,
    getExpertReview: func,
    createSearchLog: func
}

const mapStateToProps = (state) => {
    return {
        diyReturn: state.product.selectedReturn,
        isLoading: state.product.loadingReturn,  
        auditProtection: state.product.selectedProduct ? state.product.selectedProduct.auditProtection : {},
        expertReview: state.product.selectedProduct ? state.product.selectedProduct.expertReview : {},
    };
};

const mapDispatchToProps = (dispatch) => ({
    getReturn: (taxYear, productName, viewModelId, clientId) => dispatch(ProductActions.getSelectedDiyReturn(taxYear, productName, viewModelId, clientId)),
    getAuditProtection: (taxYear, viewModelId) => dispatch(ProductActions.getAuditProtection(taxYear, viewModelId)),    
    getExpertReview: (taxYear, viewModelId) => dispatch(ProductActions.getExpertReview(taxYear, viewModelId)),    
    createSearchLog: (data) => dispatch(ClientActions.createSearchLog(data)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DiyReturnPage))